import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_AutoParallelization_Vectorization = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Automatic Parallelization - Optimizations for Cache Locality and Vectorization"
    videos={[
      "https://www.youtube.com/embed/dMvSdk1K0p0",
      "https://www.youtube.com/embed/AAjk2tVOPdw",
    ]}
    takeaways={[
      { text: "for this topic there are no other good youtube videos, rely on good teacher's ppt if you don't understand the above video." },
    ]}
    questions={[
      "Create a framework for automatic parallelization and describe how you would identify opportunities for parallel execution in loops and recursive functions. Illustrate your design with an example code segment and explain how your framework improves performance.",
      "What is parallelization in the context of compiler design, and what are the different types of parallelization techniques used in optimizing programs?"
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_AutoParallelization_Vectorization;
